// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa.fa-star {
  font-size: 30px;
  margin-right: 5px;
  cursor: pointer; }
  .fa.fa-star.checked {
    color: #4330ff; }
  .fa.fa-star.unchecked {
    color: #eaeaea; }

.fa.fa-star-o {
  font-size: 30px;
  margin-right: 5px;
  cursor: pointer; }
  .fa.fa-star-o.checked {
    color: #4330ff; }
  .fa.fa-star-o.unchecked {
    color: #eaeaea; }

.eval-list-page .gray-header {
  background: #909092;
  color: white;
  padding: 10px 0 10px 20px; }

.eval-list-page hr {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 10px; }

.eval-list-page .session-name, .eval-list-page .event-eval-name {
  font-weight: bolder;
  padding: 5px 0 5px 0; }

.eval-list-page .session-time, .eval-list-page .session-room {
  color: #909092;
  font-size: 12px; }

.eval-list-page .session-room {
  padding-bottom: 5px; }

.eval-list-page a:hover {
  text-decoration: none; }

.eval-list-page .event-eval-link {
  color: #404040; }

.eval-list-page .taken-icon {
  color: #4330ff;
  font-size: 22px; }

.eval-list-page .taken-text {
  color: #909092; }

.survey-container .spinner-container {
  width: 100%;
  text-align: center;
  position: relative;
  top: 90px;
  font-size: 3em;
  margin-top: -50px; }

.survey-container .survey-iframe {
  position: relative;
  text-align: center; }
`, "",{"version":3,"sources":["webpack://./src/components/Evaluations/evaluations.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe,EAAE;EACjB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;;AAEpB;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe,EAAE;EACjB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;;AAEpB;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB,EAAE;;AAE7B;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB,EAAE;;AAErB;EACE,mBAAmB;EACnB,oBAAoB,EAAE;;AAExB;EACE,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,mBAAmB,EAAE;;AAEvB;EACE,qBAAqB,EAAE;;AAEzB;EACE,cAAc,EAAE;;AAElB;EACE,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,cAAc,EAAE;;AAElB;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,iBAAiB,EAAE;;AAErB;EACE,kBAAkB;EAClB,kBAAkB,EAAE","sourcesContent":[".fa.fa-star {\n  font-size: 30px;\n  margin-right: 5px;\n  cursor: pointer; }\n  .fa.fa-star.checked {\n    color: #4330ff; }\n  .fa.fa-star.unchecked {\n    color: #eaeaea; }\n\n.fa.fa-star-o {\n  font-size: 30px;\n  margin-right: 5px;\n  cursor: pointer; }\n  .fa.fa-star-o.checked {\n    color: #4330ff; }\n  .fa.fa-star-o.unchecked {\n    color: #eaeaea; }\n\n.eval-list-page .gray-header {\n  background: #909092;\n  color: white;\n  padding: 10px 0 10px 20px; }\n\n.eval-list-page hr {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  margin-left: 10px; }\n\n.eval-list-page .session-name, .eval-list-page .event-eval-name {\n  font-weight: bolder;\n  padding: 5px 0 5px 0; }\n\n.eval-list-page .session-time, .eval-list-page .session-room {\n  color: #909092;\n  font-size: 12px; }\n\n.eval-list-page .session-room {\n  padding-bottom: 5px; }\n\n.eval-list-page a:hover {\n  text-decoration: none; }\n\n.eval-list-page .event-eval-link {\n  color: #404040; }\n\n.eval-list-page .taken-icon {\n  color: #4330ff;\n  font-size: 22px; }\n\n.eval-list-page .taken-text {\n  color: #909092; }\n\n.survey-container .spinner-container {\n  width: 100%;\n  text-align: center;\n  position: relative;\n  top: 90px;\n  font-size: 3em;\n  margin-top: -50px; }\n\n.survey-container .survey-iframe {\n  position: relative;\n  text-align: center; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
